import { __ } from "@wordpress/i18n";
import {
  useBlockProps,
  MediaUpload,
  MediaUploadCheck,
  InspectorControls,
} from "@wordpress/block-editor";
import { Button, PanelBody, PanelRow } from "@wordpress/components";
import { useState } from "@wordpress/element";

export default function Edit({ attributes, setAttributes }) {
  const { images = [] } = attributes;
  const blockProps = useBlockProps();

  // Add images to the images array
  const addImage = (media) => {
    const newImages = media.map((item) => ({
      url: item.url || item.source_url,
      id: item.id,
      link: item.link, 
    }));
    
    setAttributes({
      images: [...images, ...newImages],
    });
  };

  // Remove image from the images array
  const removeImage = (index) => {
    const updatedImages = images.filter((_, i) => i !== index);
    setAttributes({ images: updatedImages });
  };

  return (
    <>
      <InspectorControls>
        <PanelBody title={__("Image Carousel Settings", "image-carousel")}>
          <MediaUploadCheck>
            <MediaUpload
              onSelect={addImage}
              allowedTypes={["image"]}
              multiple
              gallery
              render={({ open }) => (
                <Button onClick={open} variant="primary">
                  {__("Add Images", "image-carousel")}
                </Button>
              )}
            />
          </MediaUploadCheck>
          {images.length > 0 && (
            <PanelRow>
              <ul>
                {images.map((image, index) => (
                  <li key={image.id || image.url}>
                    <img
                      src={image.url}
                      alt={__("Carousel Image", "image-carousel")}
                      style={{ width: "100%", height: "auto" }}
                    />
                    <Button
                      isDestructive
                      onClick={() => removeImage(index)}
                    >
                      {__("Remove", "image-carousel")}
                    </Button>
                  </li>
                ))}
              </ul>
            </PanelRow>
          )}
        </PanelBody>
      </InspectorControls>

      <div {...blockProps}>
        {images.length > 0 ? (
          <div className="carousel-preview">
            {images.map((image) => (
              <img
                key={image.id || image.url}
                src={image.url}
                alt={__("Carousel Image", "image-carousel")}
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                  marginRight: "5px",
                }}
              />
            ))}
          </div>
        ) : (
          <p>{__("Add images to create a carousel", "image-carousel")}</p>
        )}
      </div>
    </>
  );
}
